import { RegexConstants } from '@/constants/regex';
import { FOLDER_ENCODED, FOLDER_UPLOADS } from '@/constants/screen-saver';
import type { ScreenSaverInfo } from '@/services/dto';

const isMP4 = (fileUrl: string) => {
    if (!fileUrl) {
        return false;
    }
    return RegexConstants.MP4_EXTENSION.test(fileUrl) || fileUrl.endsWith('.mp4');
};

const getEncodedFileUrl = (fileUrl: string) => {
    if (!fileUrl) {
        return '';
    }
    return fileUrl.replace(FOLDER_UPLOADS, FOLDER_ENCODED);
};

export const formatScreenSaver = (screenSaver?: ScreenSaverInfo[]): ScreenSaverInfo[] => {
    if (!Array.isArray(screenSaver) || !screenSaver?.length) {
        return [];
    }

    return screenSaver.map((item) => {
        const isMP4Format = isMP4(item.fileUrl);
        if (!isMP4Format) {
            return item;
        }

        const formattedFileUrl = getEncodedFileUrl(item.fileUrl);
        return {
            ...item,
            fileUrl: formattedFileUrl,
        };
    });
};
